import { render, staticRenderFns } from "./yqjl.vue?vue&type=template&id=3b33188f&scoped=true"
import script from "./yqjl.vue?vue&type=script&lang=js"
export * from "./yqjl.vue?vue&type=script&lang=js"
import style0 from "./yqjl.vue?vue&type=style&index=0&id=3b33188f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b33188f",
  null
  
)

export default component.exports